/* Fann Bliss — best next saving for the whole bag (snippets/fann-offer-nudge.liquid, cart page and drawer).
   Same engine as the bundles sections and the Shopify automatic discounts: same-family quantity prices, mixed pairs
   and 3-piece sets; only the single biggest one applies. It tries adding 1–3 pieces of each kind at its standard
   price and suggests the step that raises the saving most per piece, so the line never promises a saving that
   another discount would beat. */
(function () {
  'use strict';
  var FAMS = ['mug', 'tumbler', 'bottle', 'magsafe', 'coaster'];
  function cents(a) { return Math.round((parseFloat(a) || 0) * 100); }
  function sum(a) { return a.reduce(function (x, y) { return x + y; }, 0); }
  function money(c) {
    var f = window.FannHome && window.FannHome.money;
    if (f) return f(Math.round(c));
    var v = c / 100; return 'AED ' + (v % 1 ? v.toFixed(2) : v);
  }
  function best(R, items) {
    var byFam = {};
    items.forEach(function (it) { (byFam[it.f] = byFam[it.f] || []).push(it.p); });
    Object.keys(byFam).forEach(function (f) { byFam[f].sort(function (a, b) { return a - b; }); });
    var cnt = function (f) { return (byFam[f] || []).length; };
    var top = { save: 0, label: '' };
    function consider(s, label) { s = Math.max(0, Math.round(s)); if (s > top.save) top = { save: s, label: label }; }
    (R.ladders || []).forEach(function (L) { var n = cnt(L.fam); if (n >= (L.min || 1)) consider(Math.min(cents(L.off) * n, sum(byFam[L.fam])), L.min + '+'); });
    (R.pairs || []).forEach(function (P) {
      var n = Math.min(cnt(P.buy), cnt(P.get)); if (!n) return;
      consider(sum(byFam[P.get].slice(0, n).map(function (p) { return Math.min(p, cents(P.off)); })), 'pair');
    });
    (R.sets || []).forEach(function (S) {
      var buys = 0; (S.buy || []).forEach(function (f) { buys += cnt(f); });
      var gets = []; (S.get || []).forEach(function (f) { gets = gets.concat(byFam[f] || []); });
      gets.sort(function (a, b) { return a - b; });
      var n = Math.min(Math.floor(buys / (S.qty || 2)), gets.length); if (!n) return;
      consider(sum(gets.slice(0, n).map(function (p) { return Math.min(p, cents(S.off)); })), S.name || 'set');
    });
    return top;
  }
  function fill(t, m) { return String(t || '').replace(/\[(\w+)\]/g, function (x, k) { return m[k] != null ? m[k] : x; }); }
  function run(el) {
    var R, items;
    try { R = JSON.parse(el.querySelector('[data-fb-nudge-rules]').textContent); items = JSON.parse(el.getAttribute('data-items') || '[]'); } catch (e) { return; }
    var names = {};
    (el.getAttribute('data-w-names') || '').split(',').forEach(function (s) { var p = s.split(':'); if (p.length === 3) names[p[0].trim()] = [p[1].trim(), p[2].trim()]; });
    var bag = [], has = {};
    items.forEach(function (it) { for (var i = 0; i < (it.q || 1); i++) bag.push({ f: it.f || 'other', p: it.p || 0 }); if (it.f) has[it.f] = true; });
    if (!bag.length) return;
    var cur = parseInt(el.getAttribute('data-save'), 10) || 0, pick = null;
    FAMS.forEach(function (f) {
      if (!R.ref || !R.ref[f]) return;
      for (var k = 1; k <= 3; k++) {
        var extra = []; for (var j = 0; j < k; j++) extra.push({ f: f, p: cents(R.ref[f]) });
        var r = best(R, bag.concat(extra)), gain = r.save - cur;
        if (gain < 100) continue;
        var score = gain / k;
        if (!pick || score > pick.score + 1) pick = { f: f, k: k, save: r.save, score: score };
        break; /* the fewest pieces that raise the saving */
      }
    });
    var txt = el.querySelector('[data-fb-nudge-text]'), W = function (k) { return el.getAttribute('data-w-' + k) || ''; };
    if (pick) {
      var nm = names[pick.f] || [pick.f, pick.f], noun = (has[pick.f] ? W('more') + ' ' : '') + (pick.k === 1 ? nm[0] : nm[1]);
      txt.textContent = fill(cur > 0 ? W('better') : W('add'), { k: pick.k, noun: noun, 'new': money(pick.save), cur: money(cur) });
      el.classList.remove('is-best');
    } else if (cur > 0) {
      txt.textContent = W('best'); el.classList.add('is-best');
    } else return;
    el.hidden = false;
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-fb-nudge]'), run); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('fann:cart-refreshed', function () { setTimeout(all, 0); });
  /* the theme's own drawer refreshes swap the markup too */
  if (window.MutationObserver) {
    var t; new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
        var n = ms[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-fb-nudge]') || n.querySelector('[data-fb-nudge]'))) { clearTimeout(t); t = setTimeout(all, 30); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
